import { Partners } from 'src/presentation/pages'

export const makePartners = () => <Partners />
